module.exports = __webpack_public_path__ + "media/bootstrap-icons/play-btn-7a5bc4f5.svg";